import { render } from "./UserBookmarks.vue?vue&type=template&id=fe2daf7a&ts=true"
import script from "./UserBookmarks.vue?vue&type=script&lang=ts"
export * from "./UserBookmarks.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__